import Api from 'dcode/classes/Api'
import Geo from 'dcode/classes/Geo'

export default class ApiSite extends Api {
  static getCountry () {
    return Geo.getGlobalLang().split('-')?.[1]
  }

  static getLanguage () {
    return Geo.getGlobalLang().split('-')?.[0]
  }

  static async init () {
    const path = this._url === '/api.demo/' ? 'basic.json' : ''
    return await this._fetch({ path })
  }

  static async getPost (code) {
    const path = this._url === '/api.demo/' ? 'post.json' : `?command=item&id=${code}`
    return await this._fetch({ path })
  }

  static async getTranslation () {
    console.log('this._url', this._url)
    const path = this._url === '/api.demo/' ? 'translation.json' : '?command=translation'
    return await this._fetch({ path })
  }
}
